

















































import { Vue, Component, Prop } from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import * as SharedRoutes from "@/shared/route-names";
import { formatMMddyyyyDateString } from "@/shared/dateString";
import { useUserInvestmentAccountStore } from "@/shared/store/userInvestmentAccount";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useDrivewealthSweepStore } from "@/shared/store/drivewealthSweep";
import { DrivewealthAccount } from "@/shared/types";
import AccountHolderWidgetBase from "@/employer/components/partner-ee-service/v2/AccountHolderWidgetBase.vue";
import Pill from "@/shared/components/ui/Pill.vue";

interface InvestmentTableItem {
  custodian: string;
  accountNumber: string;
  accountStatus: string;
  investmentAccountType?: string;
  dateAccountClosed?: string;
  accountId?: number;
}

@Component({
  components: {
    Button,
    AccountHolderWidgetBase,
    Pill
  }
})
export default class AccountHolderInvestment extends Vue {
  userInvestmentAccountStore = useUserInvestmentAccountStore();
  drivewealthStore = useDrivewealthStore();
  drivewealthSweepStore = useDrivewealthSweepStore();

  SharedRoutes = SharedRoutes;
  formatMMddyyyyDateString = formatMMddyyyyDateString;

  @Prop ()
  username: string;

  @Prop ()
  partnerId: number;

  loadData () {
    const args = { username: this.username, partnerId: this.partnerId };
    this.userInvestmentAccountStore.loadInvestmentAccount(args);
    this.drivewealthStore.loadAccounts(args);
    this.drivewealthSweepStore.getSweep(args);
    this.drivewealthStore.loadAccountSummariesV2(args);
  }

  get isLoading () {
    return this.userInvestmentAccountStore.isLoading || this.drivewealthStore.accountsLoading || this.drivewealthSweepStore.sweepLoading;
  }

  get isLoaded () {
    return this.userInvestmentAccountStore.isLoaded && this.drivewealthStore.accountsLoaded && this.drivewealthSweepStore.sweepLoaded;
  }

  get displaySweepMessage () {
    return this.drivewealthSweepStore.sweepIsActive ? "Yes" : "No";
  }

  get displayTDAInvestmentAccount () {
    return this.userInvestmentAccountStore.investmentAccountNumber !== undefined;
  }

  /**
   * combine both TDA and drivewealth accounts for display
   */
  get accounts (): InvestmentTableItem[] {
    const allAccounts: InvestmentTableItem[] = [];
    if (this.drivewealthStore.accounts.items) {
      for (const dwAccount of this.drivewealthStore.accounts.items) {
        allAccounts.push(this.mapDriveWealthAccount(dwAccount));
      }
    }

    if (this.displayTDAInvestmentAccount) {
      allAccounts.push(this.mapTdaAccount());
    }
    return allAccounts;
  }

  get hasData () {
    return this.isLoaded && this.accounts.length > 0;
  }

  mapDriveWealthAccount (dwAccount: DrivewealthAccount): InvestmentTableItem {
    return {
      custodian: "DriveWealth",
      accountNumber: dwAccount.accountNumber,
      accountStatus: dwAccount.accountStatus,
      investmentAccountType: dwAccount.investmentAccountType,
      dateAccountClosed: dwAccount.dateAccountClosed,
      accountId: dwAccount.drivewealthAccountId
    };
  }

  mapTdaAccount (): InvestmentTableItem {
    return {
      custodian: "TDA",
      accountNumber: this.userInvestmentAccountStore.investmentAccountNumber,
      accountStatus: this.userInvestmentAccountStore.investmentAccountActive ? "open" : "closed"
    };
  }

  routeToInvestmentAccountDetail (dwAccountId: number) {
    const query = (this.username) ? { username: this.username } : undefined;
    const route = {
      name: SharedRoutes.DrivewealthInvestmentAccountV2,
      params: { accountId: `${dwAccountId}`, partnerId: `${this.partnerId}` },
      query
    };
    this.$router.push(route);
  }

  isOpen (accountStatus: string) {
    return accountStatus && accountStatus.toLowerCase().includes("open");
  }

  isClosed (accountStatus: string) {
    return accountStatus && accountStatus.toLowerCase().includes("closed");
  }

  disableSweep (): void {
    const args = { username: this.username, partnerId: this.partnerId };
    this.drivewealthSweepStore.pauseSweepEmployerManagement(args);
  }
}
